import { formatDate } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { constantUrl } from "../../../Shared/constantUrl";
declare var $: any;
@Component({
    selector: "app-customer-kyc-subcard-info",
    templateUrl: "./customer-kyc-subcard-info.component.html",
    styleUrls: ["./customer-kyc-subcard-info.component.scss"],
    standalone: false
})
export class CustomerKycSubcardInfoComponent implements OnInit {
  @Input() customerkycData: any;

  index: any;
  customerProfileBaseUrl: any = constantUrl.customerProfilePicUrl;
  APIResponse: any = {
    DoucumentNumber: "",
    Full_name: "",
    IsVerified: "",
    category: "",
  };
  Verify_PAN_No: any;
  Directors: any;
  Charges: any;
  docBaseUrl: any = constantUrl.CrcApplicationDocUrl;
  constructor(private _MasterService: MasterService) {}

  ngOnInit(): void {}
  onClosemodalOverlaydata() {
    $(`#modalViewVerifiedData${this.index}`).modal("hide");
  }
  ViewKYC_IsVerified(KYC, index) {
    this.index = index;
    // this._MasterService
    //   .Get_Alredy_Verified_KYC({
    //     DocumentId: KYC.KYC_DocId,
    //     KYC_DocNumber: KYC.KYC_DocNumber,
    //   })
    //   .subscribe((res: any) => {
    //     console.log("Result of api calling ", res);
    //     //let KYCDocs = this.customerModel.Type == 'Company' ? this.firmKYCDoc : this.CustomerKYCDoc;
    //     if (res.length > 0) {
    //       var Masking = KYC.KYC_DocNumber;
    //       KYC.LastVerfiedDate = res[0].LastVerfiedDate;
    //       KYC.KYC_IsVerified = 1;
    //       Masking = Masking.toUpperCase().slice(
    //         3,
    //         KYC.KYC_DocNumber.length - 3
    //       );

    //       var n = Masking.length;
    //       var ch = Masking.split("");

    //       for (var i = 0; i < n; i++) {
    //         ch[i] = "X";
    //       }
    //       if (KYC.KYC_DocId == 1) {
    //         this.APIResponse = {
    //           KYC_DocId: KYC.KYC_DocId,
    //           DoucumentNumber:
    //             KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
    //             ch.join("") +
    //             KYC.KYC_DocNumber.toUpperCase().substr(
    //               KYC.KYC_DocNumber.length - 4
    //             ),

    //           Full_name: JSON.parse(res[0].APIResponse).data.full_name,
    //           IsVerified: JSON.parse(res[0].APIResponse).data.success,
    //           category: JSON.parse(res[0].APIResponse).data.category,
    //           message_code: JSON.parse(res[0].APIResponse).message_code,
    //           LastVerfiedBy: res[0].LastVerfiedBy,
    //           LastVerfiedDate: res[0].LastVerfiedDate,
    //         };
    //       } else if (KYC.KYC_DocId == 6) {
    //         this.APIResponse = {
    //           KYC_DocId: KYC.KYC_DocId,
    //           DoucumentNumber:
    //             KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
    //             ch.join("") +
    //             KYC.KYC_DocNumber.toUpperCase().substr(
    //               KYC.KYC_DocNumber.length - 4
    //             ),

    //           Full_name: JSON.parse(res[0].APIResponse).data.full_name,
    //           IsVerified: JSON.parse(res[0].APIResponse).data.success,
    //           dob: JSON.parse(res[0].APIResponse).data.dob,
    //           gender: JSON.parse(res[0].APIResponse).data.gender,
    //           country: JSON.parse(res[0].APIResponse).data.address.country,
    //           dist: JSON.parse(res[0].APIResponse).data.address.dist,
    //           state: JSON.parse(res[0].APIResponse).data.address.state,
    //           po: JSON.parse(res[0].APIResponse).data.address.po,
    //           loc: JSON.parse(res[0].APIResponse).data.address.loc,
    //           vtc: JSON.parse(res[0].APIResponse).data.address.vtc,
    //           subdist: JSON.parse(res[0].APIResponse).data.address.subdist,
    //           street: JSON.parse(res[0].APIResponse).data.address.street,
    //           house: JSON.parse(res[0].APIResponse).data.address.house,
    //           landmark: JSON.parse(res[0].APIResponse).data.address.landmark,
    //           Pin: JSON.parse(res[0].APIResponse).data.zip,
    //           profile_image: JSON.parse(res[0].APIResponse).data.profile_image,
    //           care_of: JSON.parse(res[0].APIResponse).data.care_of,
    //           message_code: JSON.parse(res[0].APIResponse).message_code,
    //           zip: JSON.parse(res[0].APIResponse).data.zip,
    //           LastVerfiedBy: res[0].LastVerfiedBy,
    //           LastVerfiedDate: res[0].LastVerfiedDate,
    //         };
    //         if (res.length > 1) {
    //           this.Verify_PAN_No = JSON.parse(
    //             res[1].APIResponse
    //           ).data.pan_number;
    //         }
    //       } else if (KYC.KYC_DocId == 29) {
    //         Masking = Masking.toUpperCase().slice(
    //           3,
    //           KYC.KYC_DocNumber.length - 3
    //         );

    //         var n = Masking.length;
    //         var ch = Masking.split("");

    //         for (var i = 0; i < n; i++) {
    //           ch[i] = "X";
    //         }
    //         this.APIResponse = {
    //           KYC_DocId: KYC.KYC_DocId,
    //           DoucumentNumber:
    //             KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
    //             ch.join("") +
    //             KYC.KYC_DocNumber.toUpperCase().substr(
    //               KYC.KYC_DocNumber.length - 4
    //             ),

    //           business_name: JSON.parse(res[0].APIResponse).data.business_name,
    //           gst_status: JSON.parse(res[0].APIResponse).data.gstin_status,
    //           nature_bus_activities: JSON.parse(res[0].APIResponse).data
    //             .nature_bus_activities,
    //           Gst_Registration_Date: JSON.parse(res[0].APIResponse).data
    //             .date_of_registration,
    //           pan_number: JSON.parse(res[0].APIResponse).data.pan_number,
    //           SigningAutority: JSON.parse(res[0].APIResponse).data.legal_name,
    //           FirmType: JSON.parse(res[0].APIResponse).data
    //             .constitution_of_business,
    //           address: JSON.parse(res[0].APIResponse).data.address,
    //           IsVerified: JSON.parse(res[0].APIResponse).data.success,
    //           message_code: JSON.parse(res[0].APIResponse).message_code,
    //           LastVerfiedBy: res[0].LastVerfiedBy,
    //           LastVerfiedDate: res[0].LastVerfiedDate,
    //         };
    //       } else if (KYC.KYC_DocId == 28) {
    //         this.APIResponse = {
    //           KYC_DocId: KYC.KYC_DocId,
    //           DoucumentNumber:
    //             KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
    //             ch.join("") +
    //             KYC.KYC_DocNumber.toUpperCase().substr(
    //               KYC.KYC_DocNumber.length - 4
    //             ),

    //           company_name: JSON.parse(res[0].APIResponse).data.company_name,
    //           registration_number: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.registration_number,
    //           company_sub_category: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.company_sub_category,
    //           class_of_company: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.class_of_company,
    //           company_category: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.company_category,
    //           address: JSON.parse(res[0].APIResponse).data.details.company_info
    //             .registered_address,

    //           authorized_capital: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.authorized_capital,
    //           paid_up_capital: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.paid_up_capital,
    //           date_of_incorporation: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.date_of_incorporation,
    //           company_status: JSON.parse(res[0].APIResponse).data.details
    //             .company_info.company_status,

    //           directors: JSON.parse(res[0].APIResponse).data.details.directors,
    //           charges: JSON.parse(res[0].APIResponse).data.details.charges,
    //           LastVerfiedBy: res[0].LastVerfiedBy,
    //           LastVerfiedDate: res[0].LastVerfiedDate,

    //           IsVerified: JSON.parse(res[0].APIResponse).data.success,
    //           message_code: JSON.parse(res[0].APIResponse).message_code,
    //         };
    //         this.Directors = new MatTableDataSource(
    //           JSON.parse(res[0].APIResponse).data.details.directors
    //         );
    //         this.Charges = new MatTableDataSource(
    //           JSON.parse(res[0].APIResponse).data.details.charges
    //         );
    //       } else if (KYC.KYC_DocId == 5 || KYC.DocId == 5) {
    //         this.APIResponse = {
    //           KYC_DocId: 5,
    //           DoucumentNumber:
    //             KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
    //             ch.join("") +
    //             KYC.KYC_DocNumber.toUpperCase().substr(
    //               KYC.KYC_DocNumber.length - 4
    //             ),

    //           Full_name: JSON.parse(res[0].APIResponse).data.name,
    //           IsVerified: JSON.parse(res[0].APIResponse).data.success,
    //           dob: JSON.parse(res[0].APIResponse).data.dob,
    //           doi: JSON.parse(res[0].APIResponse).data.doi,
    //           doe: JSON.parse(res[0].APIResponse).data.doe,
    //           address: JSON.parse(res[0].APIResponse).data.permanent_address,
    //           vehicle_classes: JSON.parse(res[0].APIResponse).data
    //             .vehicle_classes,
    //           profile_image: JSON.parse(res[0].APIResponse).data.profile_image,
    //           ola_name: JSON.parse(res[0].APIResponse).data.ola_name,
    //           message_code: JSON.parse(res[0].APIResponse).message_code,
    //           LastVerfiedBy: res[0].LastVerfiedBy,
    //           LastVerfiedDate: res[0].LastVerfiedDate,
    //         };
    //       } else if (KYC.KYC_DocId == 2 || KYC.DocId == 2) {
    //         this.APIResponse = {
    //           KYC_DocId: 2,
    //           DoucumentNumber:
    //             KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
    //             ch.join("") +
    //             KYC.KYC_DocNumber.toUpperCase().substr(
    //               KYC.KYC_DocNumber.length - 4
    //             ),

    //           Full_name: JSON.parse(res[0].APIResponse).data.full_name,
    //           IsVerified: JSON.parse(res[0].APIResponse).data.success,
    //           address: JSON.parse(res[0].APIResponse).data.address,
    //           mobile: JSON.parse(res[0].APIResponse).data.mobile,
    //           state: JSON.parse(res[0].APIResponse).data.state,
    //           operator_code: JSON.parse(res[0].APIResponse).data.operator_code,
    //           message_code: JSON.parse(res[0].APIResponse).message_code,
    //           LastVerfiedBy: res[0].LastVerfiedBy,
    //           LastVerfiedDate: res[0].LastVerfiedDate,
    //         };
    //       } else {
    //         this.APIResponse = {
    //           KYC_DocId: KYC.KYC_DocId,
    //           DoucumentNumber:
    //             KYC.Doc_Number.toUpperCase().substr(0, 0) +
    //             ch.join("") +
    //             KYC.Doc_Number.toUpperCase().substr(KYC.Doc_Number.length - 4),
    //           Full_name: JSON.parse(res[0].APIResponse).data.name,
    //           IsVerified: JSON.parse(res[0].APIResponse).data.success,
    //           category: JSON.parse(res[0].APIResponse).data.category,
    //           message_code: JSON.parse(res[0].APIResponse).message_code,
    //           gender: JSON.parse(res[0].APIResponse).data.gender,
    //           area: JSON.parse(res[0].APIResponse).data.area,
    //           dist: JSON.parse(res[0].APIResponse).data.district,
    //           state: JSON.parse(res[0].APIResponse).data.state,
    //           age: JSON.parse(res[0].APIResponse).data.age,
    //           relation_name: JSON.parse(res[0].APIResponse).data.relation_name,
    //           relation_type: JSON.parse(res[0].APIResponse).data.relation_type,
    //           LastVerfiedBy: res[0].LastVerfiedBy,
    //           LastVerfiedDate: res[0].LastVerfiedDate,
    //         };
    //       }

    //       $(`#modalViewVerifiedData${this.index }`).modal("show");
    //       $(`#modalViewVerifiedData${this.index }`).css("z-index", "1090");

    //       console.log("console.log(this.index);",this.index);

    //       // $(`#modalViewVerifiedData${this.index}`).modal("show");
    //       // $(`#modalViewVerifiedData${this.index}`).css("z-index", "1090");
    //     }
    //   });

    this._MasterService
      .Get_Alredy_Verified_KYC({
        DocumentId: KYC.KYC_DocId,
        KYC_DocNumber: KYC.KYC_DocNumber,
      })
      .subscribe((res: any) => {
        //let KYCDocs = this.customerModel.Type == 'Company' ? this.firmKYCDoc : this.CustomerKYCDoc;
        if (res.length > 0) {
          var Masking = KYC.KYC_DocNumber;
          KYC.LastVerfiedDate = res[0].LastVerfiedDate;
          KYC.KYC_IsVerified = 1;
          Masking = Masking.toUpperCase().slice(
            0,
            KYC.KYC_DocNumber.length - 4
          );

          var n = Masking.length;
          var ch = Masking.split("");

          for (var i = 0; i < n; i++) {
            ch[i] = "X";
          }
          if (KYC.KYC_DocId == 1) {
            // this.verify_DocId = 1;
            if (res[0].SenderId == "instaveritas") {
              this.APIResponse = {
                KYC_DocId: KYC.KYC_DocId,
                DoucumentNumber: KYC.KYC_DocNumber,
                Full_name: JSON.parse(res[0].APIResponse).data.name,
                gender: JSON.parse(res[0].APIResponse).data.gender,
                type_of_holder: JSON.parse(res[0].APIResponse).data
                  .type_of_holder,
                date_of_birth: JSON.parse(res[0].APIResponse).data
                  .date_of_birth,
                masked_aadhaar_number: JSON.parse(res[0].APIResponse).data
                  .masked_aadhaar_number,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            } else if (res[0].SenderId == "GetEPay") {
              const date = new Date(JSON.parse(res[0].APIResponse).dob * 1000); // Convert seconds to milliseconds
              var dob = formatDate(date, "dd-MM-yyyy", "en-US");
              this.APIResponse = {
                KYC_DocId: KYC.KYC_DocId,
                DoucumentNumber: KYC.KYC_DocNumber,
                Full_name: JSON.parse(res[0].APIResponse).name,
                gender: JSON.parse(res[0].APIResponse).gender,
                type_of_holder: JSON.parse(res[0].APIResponse).panType,
                date_of_birth: dob,
                masked_aadhaar_number: JSON.parse(res[0].APIResponse)
                  .maskedAadhaar,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            } else {
              this.APIResponse = {
                KYC_DocId: KYC.KYC_DocId,
                DoucumentNumber:
                  KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                  ch.join("") +
                  KYC.KYC_DocNumber.toUpperCase().substr(
                    KYC.KYC_DocNumber.length - 4
                  ),

                Full_name: JSON.parse(res[0].APIResponse).data.full_name,
                IsVerified: JSON.parse(res[0].APIResponse).data.success,
                category: JSON.parse(res[0].APIResponse).data.category,
                message_code: JSON.parse(res[0].APIResponse).message_code,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            }
          } else if (KYC.KYC_DocId == 6) {
            if (res[0].SenderId == "instaveritas") {
              this.APIResponse = {
                KYC_DocId: 6,
                DoucumentNumber: KYC.KYC_DocNumber,
                Full_name: JSON.parse(res[0].APIResponse).data.name,
                //IsVerified: JSON.parse(data.KYC_Verification.APIResponse).data
                //  .success,
                dob: JSON.parse(res[0].APIResponse).data.date_of_birth,
                gender: JSON.parse(res[0].APIResponse).data.gender,

                country: JSON.parse(res[0].APIResponse).data.address.country,
                dist: JSON.parse(res[0].APIResponse).data.address.dist,
                state: JSON.parse(res[0].APIResponse).data.address.state,
                po: JSON.parse(res[0].APIResponse).data.address.po,
                loc: JSON.parse(res[0].APIResponse).data.address.loc,
                vtc: JSON.parse(res[0].APIResponse).data.address.vtc,
                subdist: JSON.parse(res[0].APIResponse).data.address.subdist,
                street: JSON.parse(res[0].APIResponse).data.address.street,
                house: JSON.parse(res[0].APIResponse).data.address.house,
                landmark: JSON.parse(res[0].APIResponse).data.address.landmark,
                Pin: JSON.parse(res[0].APIResponse).data.address.pc,
                profile_image: JSON.parse(res[0].APIResponse).data
                  .profile_image,

                care_of: JSON.parse(res[0].APIResponse).data.care_of,
                //message_code: JSON.parse(data.KYC_Verification.APIResponse)
                //  .message_code,
                zip: JSON.parse(res[0].APIResponse).data.address.pc,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            } else if (res[0].SenderId == "GetEPay") {
              this.APIResponse = {
                KYC_DocId: 6,
                DoucumentNumber: KYC.KYC_DocNumber,
                Full_name: JSON.parse(res[0].APIResponse).name,

                dob: JSON.parse(res[0].APIResponse).dob,
                gender: JSON.parse(res[0].APIResponse).gender,

                //country: JSON.parse(res[0].APIResponse).data
                //  .address.country,

                dist: JSON.parse(res[0].APIResponse).district,
                state: JSON.parse(res[0].APIResponse).state,
                po: JSON.parse(res[0].APIResponse).locality,

                //loc: JSON.parse(res[0].APIResponse).data.address
                //  .loc,
                //vtc: JSON.parse(res[0].APIResponse).data.address
                //  .vtc,
                subdist: JSON.parse(res[0].APIResponse).subDistrict,
                street: JSON.parse(res[0].APIResponse).street,
                house: JSON.parse(res[0].APIResponse).house,
                landmark: JSON.parse(res[0].APIResponse).landmark,
                Pin: JSON.parse(res[0].APIResponse).pincode,
                profile_image: JSON.parse(res[0].APIResponse).photo,

                care_of: JSON.parse(res[0].APIResponse).careof,

                zip: JSON.parse(res[0].APIResponse).pincode,
              };
            } else {
              this.APIResponse = {
                KYC_DocId: KYC.KYC_DocId,
                DoucumentNumber:
                  KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                  ch.join("") +
                  KYC.KYC_DocNumber.toUpperCase().substr(
                    KYC.KYC_DocNumber.length - 4
                  ),

                Full_name: JSON.parse(res[0].APIResponse).data.full_name,
                IsVerified: JSON.parse(res[0].APIResponse).data.success,
                dob: JSON.parse(res[0].APIResponse).data.dob,
                gender: JSON.parse(res[0].APIResponse).data.gender,
                country: JSON.parse(res[0].APIResponse).data.address.country,
                dist: JSON.parse(res[0].APIResponse).data.address.dist,
                state: JSON.parse(res[0].APIResponse).data.address.state,
                po: JSON.parse(res[0].APIResponse).data.address.po,
                loc: JSON.parse(res[0].APIResponse).data.address.loc,
                vtc: JSON.parse(res[0].APIResponse).data.address.vtc,
                subdist: JSON.parse(res[0].APIResponse).data.address.subdist,
                street: JSON.parse(res[0].APIResponse).data.address.street,
                house: JSON.parse(res[0].APIResponse).data.address.house,
                landmark: JSON.parse(res[0].APIResponse).data.address.landmark,
                Pin: JSON.parse(res[0].APIResponse).data.zip,
                profile_image: JSON.parse(res[0].APIResponse).data
                  .profile_image,
                care_of: JSON.parse(res[0].APIResponse).data.care_of,
                message_code: JSON.parse(res[0].APIResponse).message_code,
                zip: JSON.parse(res[0].APIResponse).data.zip,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
              if (res.length > 1) {
                this.Verify_PAN_No = JSON.parse(
                  res[1].APIResponse
                ).data.pan_number;
              }
            }
          } else if (KYC.KYC_DocId == 29) {
            Masking = Masking.toUpperCase().slice(
              0,
              KYC.KYC_DocNumber.length - 4
            );

            var n = Masking.length;
            var ch = Masking.split("");

            for (var i = 0; i < n; i++) {
              ch[i] = "X";
            }
            this.APIResponse = {
              KYC_DocId: KYC.KYC_DocId,
              DoucumentNumber:
                KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                ch.join("") +
                KYC.KYC_DocNumber.toUpperCase().substr(
                  KYC.KYC_DocNumber.length - 4
                ),

              business_name: JSON.parse(res[0].APIResponse).data.business_name,
              gst_status: JSON.parse(res[0].APIResponse).data.gstin_status,
              nature_bus_activities: JSON.parse(res[0].APIResponse).data
                .nature_bus_activities,
              Gst_Registration_Date: JSON.parse(res[0].APIResponse).data
                .date_of_registration,
              pan_number: JSON.parse(res[0].APIResponse).data.pan_number,
              SigningAutority: JSON.parse(res[0].APIResponse).data.legal_name,
              FirmType: JSON.parse(res[0].APIResponse).data
                .constitution_of_business,
              address: JSON.parse(res[0].APIResponse).data.address,
              IsVerified: JSON.parse(res[0].APIResponse).data.success,
              message_code: JSON.parse(res[0].APIResponse).message_code,
              LastVerfiedBy: res[0].LastVerfiedBy,
              LastVerfiedDate: res[0].LastVerfiedDate,
            };
          } else if (KYC.KYC_DocId == 28) {
            this.APIResponse = {
              KYC_DocId: KYC.KYC_DocId,
              DoucumentNumber:
                KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                ch.join("") +
                KYC.KYC_DocNumber.toUpperCase().substr(
                  KYC.KYC_DocNumber.length - 4
                ),

              company_name: JSON.parse(res[0].APIResponse).data.company_name,
              registration_number: JSON.parse(res[0].APIResponse).data.details
                .company_info.registration_number,
              company_sub_category: JSON.parse(res[0].APIResponse).data.details
                .company_info.company_sub_category,
              class_of_company: JSON.parse(res[0].APIResponse).data.details
                .company_info.class_of_company,
              company_category: JSON.parse(res[0].APIResponse).data.details
                .company_info.company_category,
              address: JSON.parse(res[0].APIResponse).data.details.company_info
                .registered_address,

              authorized_capital: JSON.parse(res[0].APIResponse).data.details
                .company_info.authorized_capital,
              paid_up_capital: JSON.parse(res[0].APIResponse).data.details
                .company_info.paid_up_capital,
              date_of_incorporation: JSON.parse(res[0].APIResponse).data.details
                .company_info.date_of_incorporation,
              company_status: JSON.parse(res[0].APIResponse).data.details
                .company_info.company_status,

              directors: JSON.parse(res[0].APIResponse).data.details.directors,
              charges: JSON.parse(res[0].APIResponse).data.details.charges,
              LastVerfiedBy: res[0].LastVerfiedBy,
              LastVerfiedDate: res[0].LastVerfiedDate,

              IsVerified: JSON.parse(res[0].APIResponse).data.success,
              message_code: JSON.parse(res[0].APIResponse).message_code,
            };
            this.Directors = new MatTableDataSource(
              JSON.parse(res[0].APIResponse).data.details.directors
            );
            this.Charges = new MatTableDataSource(
              JSON.parse(res[0].APIResponse).data.details.charges
            );
          } else if (KYC.KYC_DocId == 5 || KYC.DocId == 5) {
            if (res[0].SenderId == "instaveritas") {
              this.APIResponse = {
                KYC_DocId: 5,
                DoucumentNumber: KYC.KYC_DocNumber,
                Full_name: JSON.parse(res[0].APIResponse).data.name,
                dob: JSON.parse(res[0].APIResponse).data.dob,
                doi: JSON.parse(res[0].APIResponse).data.date_of_issue,
                doe: JSON.parse(res[0].APIResponse).data.categories[0]
                  .valid_upto,

                address: JSON.parse(res[0].APIResponse).data.permanent_address,
                rto_name: JSON.parse(res[0].APIResponse).data.rto_name,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            } else {
              this.APIResponse = {
                KYC_DocId: 5,
                DoucumentNumber:
                  KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                  ch.join("") +
                  KYC.KYC_DocNumber.toUpperCase().substr(
                    KYC.KYC_DocNumber.length - 4
                  ),

                Full_name: JSON.parse(res[0].APIResponse).data.name,
                IsVerified: JSON.parse(res[0].APIResponse).data.success,
                dob: JSON.parse(res[0].APIResponse).data.dob,
                doi: JSON.parse(res[0].APIResponse).data.doi,
                doe: JSON.parse(res[0].APIResponse).data.doe,
                address: JSON.parse(res[0].APIResponse).data.permanent_address,
                vehicle_classes: JSON.parse(res[0].APIResponse).data
                  .vehicle_classes,
                profile_image: JSON.parse(res[0].APIResponse).data
                  .profile_image,
                ola_name: JSON.parse(res[0].APIResponse).data.ola_name,
                message_code: JSON.parse(res[0].APIResponse).message_code,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            }
          } else if (KYC.KYC_DocId == 2 || KYC.DocId == 2) {
            if (res[0].SenderId == "GetEPay") {
              //this.verify_DocId = 2;
              this.APIResponse = {
                KYC_DocId: 2,
                DoucumentNumber:
                  KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                  ch.join("") +
                  KYC.KYC_DocNumber.toUpperCase().substr(
                    KYC.KYC_DocNumber.length - 4
                  ),
                Full_name: JSON.parse(res[0].APIResponse).consumerName,
                IsVerified:
                  JSON.parse(res[0].APIResponse).statusCode == 200
                    ? true
                    : false,
                address: JSON.parse(res[0].APIResponse).address,
                mobile: JSON.parse(res[0].APIResponse).mobileNumber,
                state: "",
                operator_code: "",
                message_code: "success",
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            } else {
              // this.verify_DocId = 2;
              this.APIResponse = {
                KYC_DocId: 2,
                DoucumentNumber:
                  KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                  ch.join("") +
                  KYC.KYC_DocNumber.toUpperCase().substr(
                    KYC.KYC_DocNumber.length - 4
                  ),

                Full_name: JSON.parse(res[0].APIResponse).data.full_name,
                IsVerified: JSON.parse(res[0].APIResponse).data.success,
                address: JSON.parse(res[0].APIResponse).data.address,
                mobile: JSON.parse(res[0].APIResponse).data.mobile,
                state: JSON.parse(res[0].APIResponse).data.state,
                operator_code: JSON.parse(res[0].APIResponse).data
                  .operator_code,
                message_code: JSON.parse(res[0].APIResponse).message_code,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            }
          } else {
            //this.verify_DocId = KYC.KYC_DocId;
            if (res[0].SenderId == "GetEPay") {
              this.APIResponse = {
                KYC_DocId: KYC.KYC_DocId,
                DoucumentNumber: KYC.KYC_DocNumber,
                Full_name: JSON.parse(res[0].APIResponse).name,
                IsVerified: JSON.parse(res[0].APIResponse).isActive,
                gender:
                  JSON.parse(res[0].APIResponse).gender == "M"
                    ? "Male"
                    : "Female",
                area:
                  JSON.parse(res[0].APIResponse).acName +
                  " " +
                  JSON.parse(res[0].APIResponse).partName +
                  " " +
                  JSON.parse(res[0].APIResponse).partNumber +
                  " " +
                  JSON.parse(res[0].APIResponse).pcName +
                  " " +
                  JSON.parse(res[0].APIResponse).psName,
                dist: JSON.parse(res[0].APIResponse).district,
                state: JSON.parse(res[0].APIResponse).state,
                age: JSON.parse(res[0].APIResponse).age,
                relation_name:
                  JSON.parse(res[0].APIResponse).relativeName +
                  " " +
                  JSON.parse(res[0].APIResponse).relativeNameVernacular2,
                relation_type: JSON.parse(res[0].APIResponse)
                  .relativeRelationshipType,
                care_of: JSON.parse(res[0].APIResponse)
                  .relativeRelationshipType,
                message_code: "",
              };
            } else {
              this.APIResponse = {
                KYC_DocId: KYC.KYC_DocId,
                DoucumentNumber:
                  KYC.KYC_DocNumber.toUpperCase().substr(0, 0) +
                  ch.join("") +
                  KYC.KYC_DocNumber.toUpperCase().substr(
                    KYC.KYC_DocNumber.length - 4
                  ),
                Full_name: JSON.parse(res[0].APIResponse).data.name,
                IsVerified: JSON.parse(res[0].APIResponse).data.success,
                category: JSON.parse(res[0].APIResponse).data.category,
                message_code: JSON.parse(res[0].APIResponse).message_code,
                gender: JSON.parse(res[0].APIResponse).data.gender,
                area: JSON.parse(res[0].APIResponse).data.area,
                dist: JSON.parse(res[0].APIResponse).data.district,
                state: JSON.parse(res[0].APIResponse).data.state,
                age: JSON.parse(res[0].APIResponse).data.age,
                relation_name: JSON.parse(res[0].APIResponse).data
                  .relation_name,
                relation_type: JSON.parse(res[0].APIResponse).data
                  .relation_type,
                LastVerfiedBy: res[0].LastVerfiedBy,
                LastVerfiedDate: res[0].LastVerfiedDate,
              };
            }
          }
          // this.verify_DocId = KYC.KYC_DocId;
          if (KYC.KYC_DocId == 28 || KYC.KYC_DocId == 29) {
            // this.Apply = false;
            $(`#modalViewVerifiedData${this.index}`).modal("show");
            $(`#modalViewVerifiedData${this.index}`).css("z-index", "1090");
          } else {
            if (
              res[0].SenderId == "instaveritas" ||
              res[0].SenderId == "GetEPay"
            ) {
              $(`#modalOverlayinstaveritasdata${this.index}`).modal("show");
              $(`#modalOverlayinstaveritasdata${this.index}`).css(
                "z-index",
                "1090"
              );
            } else {
              $(`#modalViewVerifiedData${this.index}`).modal("show");
              $(`#modalViewVerifiedData${this.index}`).css("z-index", "1090");
            }
            // $(`#modalVerifiedData`).modal("show");
            //$(`#modalVerifiedData`).css("z-index", "1090");
          }
          // this.LMS_GetLoanDetails();
        } else {
          KYC.LastVerfiedDate = "";
          KYC.KYC_IsVerified = 0;
        }
      });
  }
}
